(function() {
	"use strict";

	angular.module( "ATMGurus" )

	.directive( "navMenu", [
		"ApiQuery",
		"Navigation",
		function( ApiQuery, Navigation ) {
			return {
				restrict: "AE",
				priority: 1000,
				link: function( scope, element, attrs ) {

					function buildNode( link ) {

						var activeClass = undefined;
						var target = "_self";

						if ( Navigation.isActiveSub( link.url ) ) {
							activeClass = "is-current";
						}

						if ( link.new_tab ) {
							target = "_blank";
						}

						// full attribute
						// shows either a formatted menu item or a simple list item
						if ( attrs.full ) {
							return element.append( "<li class='menu-item'><a class='menu-link " +  activeClass + "' href='" + link.url + "' target='" + target + "'>" + link.title + "</a></li>" )
						}
						else {
							return element.append( "<li><a href='" + link.url + "' target='" + target + "'>" + link.title + "</a></li>" )
						}
					}

					if ( !attrs.name ) {
						return
					}

					Navigation.fetchMenu( attrs.name )
						.then( function( menu_items ) {
							if ( attrs.name !== "sitemap" ) {
								Navigation.activeNavMenu = attrs.name;
								// build out the html structure
								_.forEach( menu_items, function( link ) {
									element.append( buildNode( link ) )
								})
							}
						})
				}
			}
		}
	])
})()


// WEBPACK FOOTER //
// ./src/app/directives/navMenu.js